import {ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, HostBinding, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {INgClass, PersistentComponent} from '@ideals/types';
import {Utils} from '@ideals/utils';

const NG_VALUE_ACCESSOR_PROVIDER = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CheckboxComponent),
  multi: true
};

@Component({
  selector: 'ideals-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [NG_VALUE_ACCESSOR_PROVIDER],
  standalone: false,
})
export class CheckboxComponent extends PersistentComponent implements ControlValueAccessor {
  private static readonly _checkedClassName = 'checked';
  private static readonly _disabledClassName = 'disabled';
  private static readonly _filledIconCheckClassName = 'icons-checkbox';
  private static readonly _indeterminateClassName = 'indeterminate';
  private static readonly _centredClassName = 'centred';

  @Input()
  public set value(checked: boolean) {
    this._value = checked;
  }

  public get value(): boolean {
    return this._value;
  }

  @Input()
  public set id(id: string) {
    this._id = id;
  }

  public get id(): string {
    return this._id;
  }

  @Input()
  public indeterminate: boolean;

  @Input()
  public isDisabled: boolean;

  @Input()
  public readonly: boolean;

  @Input()
  public centred: boolean;

  @Input()
  public dataIdealsAttr = 'input';

  @HostBinding('class.ideals-checkbox')
  public checkboxClass = true;

  private _id = `checkbox-${Utils.getUniqueId}`;
  private _value: boolean;
  private _controlChangeFn: (checked: boolean) => void;

  constructor(private readonly _changeDetector: ChangeDetectorRef) {
    super();
    this._controlChangeFn = (): any => {
    };
  }

  public get checkboxClasses(): INgClass {
    return {
      [CheckboxComponent._checkedClassName]: !!this.value,
      [CheckboxComponent._filledIconCheckClassName]: !!this.value,
      [CheckboxComponent._disabledClassName]: this.isDisabled,
      [CheckboxComponent._indeterminateClassName]: this.indeterminate && !this.value,
      [CheckboxComponent._centredClassName]: this.centred,
    };
  }

  public get isInputDisabled(): boolean {
    return this.isDisabled || this.readonly;
  }

  public toggle(): void {
    this.value = !this.value;
    this._controlChangeFn(this.value);
  }

  public registerOnChange(fn: any): void {
    this._controlChangeFn = fn;
  }

  public registerOnTouched(fn: any): void {
  }

  public writeValue(checked: boolean): void {
    this.value = checked;
    this._changeDetector.detectChanges();
  }

  public onChange(event: any): void {
    this.value = event.target.checked;
    this._controlChangeFn(this.value);
  }
}
